import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import * as clipboard from "clipboard-polyfill";
import {
    translate,
} from '../../helperFunctions/translation';

interface DynamicLinkInterface {
    open: boolean;
    link: string;
    handleClose: () => void;
}
const DynamicLinkDialog: React.FC<DynamicLinkInterface> = (props) => {
  const copy =  () => {
    clipboard.writeText(props.link);
    props.handleClose();
  };
  return (
    <div>
      <Dialog
        open={props.open}
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {props.link}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={copy} color='primary'>
            {translate('newCopyDynamicLink', {})}
          </Button>
        </DialogActions>
      </Dialog>
      </div>
  );
}
export default DynamicLinkDialog;